import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddTeamMessage = () => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    image: null
  });
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'image') {
      const file = files[0];
      setFormData((prev) => ({ ...prev, image: file }));
      setPreview(file ? URL.createObjectURL(file) : null);
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);

    try {
      const data = new FormData();
      data.append('name', formData.name);
      data.append('description', formData.description);
      if (formData.image) {
        data.append('image', formData.image);
      }

      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/message`, data);

      toast.success('✅ Team message added successfully!');

      // Reset form
      setFormData({
        name: '',
        description: '',
        image: null
      });
      setPreview(null);
    } catch (error) {
      console.error(error);
      toast.error('❌ Failed to add team message!');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Add advertising</h4>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="name" className="form-label">
            Name
          </label>
          <input type="text" className="form-control" id="name" name="name" value={formData.name} onChange={handleChange} required />
        </div>

        <div className="mb-3">
          <label htmlFor="description" className="form-label">
            Description
          </label>
          <textarea
            className="form-control"
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            rows={4}
            required
          />
        </div>

        <div className="mb-3">
          <label htmlFor="image" className="form-label">
            Image (optional)
          </label>
          <input type="file" className="form-control" id="image" name="image" accept="image/*" onChange={handleChange} />
        </div>

        {preview && (
          <div className="mb-3">
            <p className="text-white">Preview:</p>
            <img src={preview} alt="preview" width={150} className="rounded" />
          </div>
        )}

        <button type="submit" className="btn btn-lg addbtn" disabled={loading}>
          {loading ? 'Adding...' : 'Add New'}
        </button>
      </form>

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default AddTeamMessage;
